import styled, { css, useTheme } from "styled-components";
import Text from "common/Typography/Text";
import React from "react";
import { AuthTwoFAStepComponent } from "features/settings/Security/TwoFA/types";
import { TwoFAFooter } from "features/settings/Security/TwoFA/TwoFAFooter";
import { AppStore, GooglePlay } from "common/Icons/Icons";
import { typography } from "@shared/common/Themes/typography";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { LanguageNameSpaces } from "@shared/types";

export const StepOne: AuthTwoFAStepComponent = ({
  onUpdateStepStatus,
  index,
}) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.SETTINGS);
  const { isNewLook } = useTheme();
  return (
    <>
      <Text
        $weight={
          isNewLook
            ? typography.fontWeights.NORMAL
            : typography.fontWeights.MEDIUM
        }
        style={{ textAlign: "center" }}
      >
        {t("two_fa.step_one_instruction")}
      </Text>
      <StoreBadges>
        <MobileAppStoreBadgeWrapper
          href="https://apps.apple.com/us/app/google-authenticator/id388497605"
          target="_blank"
        >
          <StyledAppStore />
        </MobileAppStoreBadgeWrapper>
        <MobileAppStoreBadgeWrapper
          href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en_US&gl=US"
          target="_blank"
        >
          <StyledGooglePlay />
        </MobileAppStoreBadgeWrapper>
      </StoreBadges>
      <TwoFAFooter onClick={() => onUpdateStepStatus("finish", index)}>
        {t("two_fa.next_button")}
      </TwoFAFooter>
    </>
  );
};

const MobileAppStoreBadgeWrapper = styled.a`
  width: 160px;
  margin-top: 10px;
  border: 1px solid ${(p) => p.theme.colors.basic};
  border-radius: 6px;
  padding: 0 12px;
  flex: 1;
  fill: ${(p) => p.theme.colors.textColor};
  ${(p) =>
    p.theme.isNewLook &&
    css`
      margin-top: 4px;
      border: ${p.theme.borders.card};
      border-radius: ${p.theme.radii.control}px;
      transition: border-color 0.15s ease, background 0.15s ease;
      &:hover {
        border-color: ${p.theme.colors.secondaryText};
        background: ${p.theme.colors.cardLightBgColor};
      }
    `}
`;
const iconStyle = css`
  width: 100%;
  height: 100%;
`;
const StyledAppStore = styled(AppStore)`
  ${iconStyle}
`;
const StyledGooglePlay = styled(GooglePlay)`
  ${iconStyle}
`;

const StoreBadges = styled.div`
  display: flex;
  column-gap: 12px;
  @media (max-width: 359.98px) {
    flex-wrap: wrap;
    justify-content: center;
    row-gap: 8px;
    > a {
      flex: 0 1 140px;
    }
  }
`;
